<div class="event-form-wrap event-form" (keydown.enter)="$event.preventDefault()">
    <!--<div class="header">-->
    <!--<h2 [class.text-disabled]="!toggles.manualEvents">Add Event Manually</h2>-->
    <!--<upgrade-button [show]="!toggles.manualEvents" [css]="'upgrade-create-event'"></upgrade-button>-->
    <!--</div>-->
    <ig-field label="Event Title *" [(ngModel)]="command.name" [disabled]="!toggles.manualEvents" [isRequired]="true"
        icon="stars" [formControl]="createEventForm.get('name')">
    </ig-field>
    <ig-field label="Event Host *" [(ngModel)]="command.host" [disabled]="!toggles.manualEvents" [isRequired]="true"
        icon="person" [formControl]="createEventForm.get('host')">
    </ig-field>
    <ig-field label="Location / Venue Name" icon="location_city" [formControl]="createEventForm.get('venue')"
        [(ngModel)]="command.venue">
    </ig-field>
    <ig-address-input [label]="addressInputLabel"
        label2="Start typing the physical address and select from a verified Google Maps address below"
        matTooltip="please type and select an address from the dropdown" [(ngModel)]="command.address"
        [disabled]="!toggles.manualEvents" [formControl]="createEventForm.get('address')">
    </ig-address-input>
    <span *ngIf="isAllowOnlineEvents">
        <mat-checkbox class="m-b-3" [(ngModel)]="command.isOnlineEvent" (change)="virtualEventChange()">
            Virtual Event</mat-checkbox>
        <mat-icon style="color:lightgray;margin-right:16px"
            matTooltip="Virtual events don't have physical addresses">info</mat-icon>
    </span>

    <mat-checkbox class="m-b-3" [(ngModel)]="command.isHybridEvent" (change)="hybridEventChange()">Hybrid Event
    </mat-checkbox>
    <mat-icon style="color:lightgray" matTooltip="Hybrid events are both virtual and in-person">info</mat-icon>
    <ig-field #inputElement label="Event Organizer Email Address" label2="We will only use this email for admin purposes, in case we need to contact you about your event. It will
        not be displayed publicly in your event listing" [isRequired]="false" icon="mail"
        [formControl]="createEventForm.get('organizerEmail')" [(ngModel)]="command.organizerEmail">
    </ig-field>
    <ig-field label="Event URL for more information (if applicable)" [(ngModel)]="command.eventLink" icon="link"
        [disabled]="!toggles.manualEvents" [formControl]="createEventForm.get('eventLink')">
    </ig-field>
    <ig-field label="Event Host Website URL" icon="link" [formControl]="createEventForm.get('hostLink')"
        [(ngModel)]="command.hostLink">
    </ig-field>
    <ig-field label="Get Tickets URL (if applicable)" icon="receipt" [formControl]="createEventForm.get('ticketUri')"
        [(ngModel)]="command.ticketUri">
    </ig-field>
    <div class="flex time-input relative" *ngFor="let timeRange of command.eventTimes;let i=index">
        <div style="flex: 12">
            <div style="position: absolute;top:0;left:0;color:#99abb4">From</div>
            <div style="position: absolute;color:#99abb4" [ngStyle]="{'left':command.frequency!=='custom'?'50%':'46%'}">
                To
            </div>
            <ig-datetime-input #dateTimeInput [frequency]="command.frequency"
                [startDate]="command.eventTimes[i].startTime" [endDate]="command.eventTimes[i].endTime"
                [disabled]="!toggles.manualEvents" [allowNoTime]="true" [timezone]="command.timezone"
                (change)="setEventTime($event, command.eventTimes[i])"></ig-datetime-input>
        </div>

        <div *ngIf="command.frequency==='custom'" class="time-plus">
            <ig-button *ngIf="!i" [disabled]="!toggles.manualEvents" (trigger)="addTimeRange()"
                matTooltip="Add more dates">+
            </ig-button>
            <ig-button *ngIf="i" [disabled]="!toggles.manualEvents" (trigger)="removeTimeRange(i)" color="cancel"
                matTooltip="Remove this date">-
            </ig-button>
        </div>
    </div>
    <ig-row class="relative timezone-frequency">
        <ig-col [xs]="6">
            <ig-city-selector type="text" [label]="timezoneLabel" [(ngModel)]="timezoneAddress" [isRequired]="false"
                (onAddressClear)="resetTimezoneLabel()" [disabled]="!toggles.manualEvents||!manualSetTimezone"
                (ngModelChange)="citySelected()" [formControl]="createEventForm.get('timezone')"></ig-city-selector>
            <a *ngIf="!manualSetTimezone"
                (click)="manualSetTimezone=true;timezoneLabel='Enter a city to set timezone *'">change timezone</a>
        </ig-col>
        <ig-col [xs]="6" style="padding-left: 12px">
            <ig-select [(ngModel)]="frequencyItems" label="Frequency" (onOpen)="setFrequencyDropdown()"
                (itemSelected)="frequencySourceChange($event)" [disabled]="!toggles.manualEvents">
            </ig-select>
            <div *ngIf="totalTimes&&command.frequency!=='custom'" style="color:#99abb4;margin-bottom:22px">
                <span><b>{{totalTimes.split('Dates')[0]}} Dates</b></span><span
                    style="margin-left: 16px">{{totalTimes.split('Dates')[1]}}</span>
            </div>
        </ig-col>
    </ig-row>

    <ig-row>
        <ig-col [md]="6">
            <mat-form-field class="text-area">
                <textarea #description matInput placeholder="Description" type="textArea"
                    [(ngModel)]="command.description" [disabled]="!toggles.manualEvents" (input)="descriptionChange()"
                    [formControl]="createEventForm.get('description')">
                        </textarea>
            </mat-form-field>
        </ig-col>
        <ig-col [md]="6">
            <ig-image-selector label="Upload Event Image" [label2]="imageUploaderLabel2" [command]="command"
                [disabled]="!toggles.manualEvents" (onImageChanged)="onImageChange($event)"
                [selectedImageData]="resizeImageTemp">
            </ig-image-selector>
            <ig-image-resize *ngIf="resizeImageTemp" [imageToResize]="resizeImageTemp"
                (onImageResized)="imageResized($event)"></ig-image-resize>
            <mat-checkbox *ngIf="isImageChanged" [(ngModel)]="hasCopyrights">Please note that any images uploaded or
                used in this software must either be royalty-free or owned by the client. By uploading or using an
                image, you acknowledge that you have the necessary rights to use it and that you will be solely
                responsible for any copyright infringement or other legal issues that may arise from the use of the
                image. We strongly advise our users to exercise due diligence and ensure that they have the necessary
                rights to use any images uploaded or used in this software.
            </mat-checkbox>
        </ig-col>
    </ig-row>

    <mat-checkbox class="m-b-3" [(ngModel)]="command.isApproved">
        Set as Approved
    </mat-checkbox>
    <ig-button [isAsync]="true" [disabled]="isFormInvalid||!toggles.manualEvents" color="accent" size="md"
        style="margin-top:0" (trigger)="createEvent($event)">
        Create event
    </ig-button>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/manually.add/create.event/create.event.component.html